import axios from '@axios'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCustomers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/customers', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchCustomer(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/customers/${queryParams.id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addCustomer(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/customers', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCustomer(ctx, queryParams) {
      return new Promise((resolve, reject) => {
         axiosIns.delete('/customers', { params: queryParams })
         .then(response=>resolve(response))
         .catch(error=>reject(error))
      })
    },
    exportClients(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/customers/export', {
          params: queryParams,
          responseType: "blob",
        })
        .then(response=>resolve(response))
        .catch(error=>reject(error))
     })
    },
    fetchQuotations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/quotations/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchInvoices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/invoices", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReceipts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/receipts/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
  
}
